import { useState, useEffect } from 'react';

/**
 * Environment detection hook - auto-detects localhost vs production
 * No user control - environment determines database routing automatically
 * Used for displaying environment status indicators in the UI
 */
export const useDevMode = () => {
    const [isDevMode, setIsDevMode] = useState(false);

    useEffect(() => {
        // Check hostname once on mount
        const isLocalhost = window.location.hostname === 'localhost';
        setIsDevMode(isLocalhost);

        console.log(`🧪 Environment Detection: ${isLocalhost ? 'DEVELOPMENT (localhost → dancelocale-dev)' : 'PRODUCTION (domain → dancelocale)'}`);

        // Note: dance-locale-dev-mode localStorage is used by purchase session flow - do not remove it
    }, []);

    return {
        isDevMode,              // true if localhost, false if production domain
        isQualifiedUser: true,  // Always true (no qualification needed - env determines routing)
        // No toggle functions - environment is auto-detected from hostname
    };
};

export default useDevMode;
